/**
 * Main API entry point.
 * Aggregates domain-specific services for backward compatibility and easy access.
 */
import { setGlobalLogoutHandler, getErrorMessage, serverRootUrl } from './client';
import { authService } from '@/services/authService';
import { userService } from '@/services/userService';
import { chatService } from '@/services/chatService';
import { echoService } from '@/services/echoService';
import { creditService } from '@/services/creditService';
import { favoriteService } from '@/services/favoriteService';
import { analyticsService } from '@/services/analyticsService';
import { surveyService } from '@/services/surveyService';
import { ratingsService } from '@/services/ratingsService';
import { connectedAccountsService } from '@/services/connectedAccountsService';
import { taxonomyService } from '@/services/taxonomyService';
import { groupChatService } from '@/services/groupChatService';
import { payoutsService } from '@/services/payoutsService';
import { developerService } from '@/services/developerService';

// Export core utilities
export { setGlobalLogoutHandler, getErrorMessage, serverRootUrl };

/**
 * Aggregated API namespace — `api.auth`, `api.chat`, etc. Each property is a
 * domain service. Use this single import in callers; underlying services may
 * be refactored without touching every consumer.
 */
export const api = {
  auth: authService,
  users: userService,
  chat: chatService,
  echoes: echoService,
  credits: creditService,
  favorites: favoriteService,
  analytics: analyticsService,
  surveys: surveyService,
  ratings: ratingsService,
  connectedAccounts: connectedAccountsService,
  taxonomy: taxonomyService,
  groupChat: groupChatService,
  payouts: payoutsService,
  developer: developerService,
} as const;
